import { api } from './api';

const makeRoleHeaders = (userRoleUuid) => {
    if (!userRoleUuid) {
        throw new Error('Missing active user role UUID.');
    }

    return {
        'USER-ROLE': userRoleUuid
    };
};

export const listLocations = async ({
    userRoleUuid,
    paginationLimit = 50,
    paginationToken = null
}) =>
    api.get('/locations', {
        headers: {
            ...makeRoleHeaders(userRoleUuid),
            'PAGINATION-LIMIT': paginationLimit,
            ...(paginationToken ? { 'PAGINATION-TOKEN': paginationToken } : {})
        }
    });

export const fetchLocation = async ({ userRoleUuid, locationUuid }) =>
    api.post(
        '/locations/fetch',
        { location: locationUuid },
        {
            headers: makeRoleHeaders(userRoleUuid)
        }
    );

export const createLocation = async ({ userRoleUuid, payload }) =>
    api.post('/locations', payload, {
        headers: makeRoleHeaders(userRoleUuid)
    });

export const updateLocation = async ({ userRoleUuid, payload }) =>
    api.patch('/locations', payload, {
        headers: makeRoleHeaders(userRoleUuid)
    });
